// tslint:disable:no-empty-interface
import { IFormGroupProps, IOptionProps, ISliderProps } from '@blueprintjs/core'
import { SubmitCallback, SubmitHandler } from 'final-form'
import { FieldRenderProps } from 'react-final-form'
import { FieldArrayProps, FieldArrayRenderProps } from 'react-final-form-arrays'
import { TranslationFunction } from 'react-i18next'
import { ReactNode } from 'react-redux'
import { Action } from 'redux'

type InputTypes = 'text' | 'password' | 'number' | 'radio' | 'checkbox' | 'search' | 'hidden'
interface WithInputType {
  type: InputTypes
}

interface BaseExtendedFieldProps extends IFormGroupProps {
  // label: string
  placeholder: string
  required?: ReactNode
  translate?: TranslationFunction
}
export type FieldAdapterProps<T> = FieldRenderProps &
  Partial<T> & {
    enableSyncControl?: boolean
    onSyncChange?(fieldName: string, newValue: boolean): void
  }

export type FieldArrayAdapterProps<T> = FieldArrayRenderProps &
  Partial<T> & {
    enableSyncControl?: boolean
    onSyncChange?(fieldName: string, newValue: boolean): void
  }

export interface DatepickerProps extends BaseExtendedFieldProps {}

export interface TextInputProps extends BaseExtendedFieldProps, WithInputType {
  // type: 'text' | 'password' | 'number'
  autoFocus?: boolean
  regEx?: RegExp
  prefixText?: string
  suffixText?: string
}

export interface FileInputProps extends BaseExtendedFieldProps, WithInputType {}
export interface SliderProps extends BaseExtendedFieldProps, ISliderProps {}

export interface SuggestProps extends BaseExtendedFieldProps, WithInputType {}

export interface MultiselectProps extends BaseExtendedFieldProps, FieldArrayProps {}

export interface TextAreaProps extends BaseExtendedFieldProps {
  rows: number
  autoFocus?: boolean
  hint?: string
  hideLabel?: boolean
  maxCharsCount?: number
}

export interface HtmlEditorProps extends BaseExtendedFieldProps {
  autoFocus?: boolean
  editorId?: string
  isSmallEditor?: boolean
  hasMoreLines?: boolean
}

export interface RadioProps extends BaseExtendedFieldProps, WithInputType {
  // type: 'radio'
  options: IOptionProps[]
}

export interface SelectProps extends BaseExtendedFieldProps {
  items: Array<{ text: string; value: number | string }>
  hideNoSelectedOption: boolean
  noSelectedOptionText: string
  prefixText?: string
  suffixText?: string
  fill?: boolean
}

export interface CheckboxProps extends BaseExtendedFieldProps, WithInputType {
  // type: 'checkbox'
}

export interface ExtendedFieldProps extends TextInputProps, TextAreaProps, RadioProps, CheckboxProps {}

export interface FormAction<P extends FormActionPayload<object> = FormActionPayload<object>> extends Action {
  payload: P
}

export interface FormMetaAction<
  P extends { item: FormActionPayload<object>; meta: object } = { item: FormActionPayload<object>; meta: object }
> extends Action {
  payload: P
}

export type FormActionPayload<P extends object = object> = {
  values: P
  complete: SubmitCallback
}

export type SelectOption = {
  value: number
  text: string
}

export { SubmitCallback, SubmitHandler }



// WEBPACK FOOTER //
// ./src/modules/forms/types.ts